"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var OpenApiErrors;
(function (OpenApiErrors) {
    OpenApiErrors["NO_CREDITS_LEFT"] = "You have used up all your api credits, try again in 1 minute.";
    OpenApiErrors["NO_OPEN_API_SETUP"] = "Your account hasn't been set up to use the Open API, please contact Technis.";
})(OpenApiErrors = exports.OpenApiErrors || (exports.OpenApiErrors = {}));
var AuthErrors;
(function (AuthErrors) {
    AuthErrors["API_KEY_EXPECTED"] = "This key is invalid, it hasn't been made to be used with the Open API.";
    AuthErrors["API_KEY_DELETED"] = "This Open API key is not usable anymore.";
    AuthErrors["API_NOT_ALLOWED"] = "You are not allowed to use the Open API.";
    AuthErrors["BAD_CREDENTIALS"] = "Wrong email/password.";
    AuthErrors["INVALID_TOKEN"] = "Token is invalid.";
    AuthErrors["NOT_AUTHORIZED"] = "You're not authorized to perform this action";
    AuthErrors["NOT_VALID_USER"] = "The user cannot be found.";
    AuthErrors["TOKEN_EXPECTED"] = "This token is invalid, it has been made to be used with the Open API.";
    AuthErrors["TOKEN_EXPIRED"] = "Your token has expired, please get a new one.";
    AuthErrors["NO_OPEN_API_SETUP"] = "Your account hasn't been set up to use the Open API, please contact Technis.";
    AuthErrors["STOP_N_GO_DELETED"] = "This Stop&Go token is not usable anymore.";
    AuthErrors["STOP_N_GO_EXPIRED"] = "You are using a temporary token that has expired and has been deactivated.";
    AuthErrors["OTP_CODE_EXPECTED"] = "OTP is enabled, please login with the code sent to you.";
    AuthErrors["INVALID_OTP"] = "OTP code invalid.";
})(AuthErrors = exports.AuthErrors || (exports.AuthErrors = {}));
var OrganizationErrors;
(function (OrganizationErrors) {
    OrganizationErrors["NAME_ALREADY_IN_USE"] = "The organization name is already used";
    OrganizationErrors["ORGANIZATION_NOT_FOUND"] = "The organization couldn't be found";
})(OrganizationErrors = exports.OrganizationErrors || (exports.OrganizationErrors = {}));
var ZoneErrors;
(function (ZoneErrors) {
    ZoneErrors["CONTAINS_CHILDREN"] = "The zone still contains children";
    ZoneErrors["ZONE_NOT_FOUND"] = "The zone couldn't be found";
})(ZoneErrors = exports.ZoneErrors || (exports.ZoneErrors = {}));
var EventErrors;
(function (EventErrors) {
    EventErrors["EVENT_NOT_FOUND"] = "The event couldn't be found";
})(EventErrors = exports.EventErrors || (exports.EventErrors = {}));
var CountErrors;
(function (CountErrors) {
    CountErrors["COUNT_NOT_FOUND"] = "No count found for the date";
})(CountErrors = exports.CountErrors || (exports.CountErrors = {}));
var StatusErrors;
(function (StatusErrors) {
    StatusErrors["UNKWOWN_STATUS"] = "This status code is not attributed";
})(StatusErrors = exports.StatusErrors || (exports.StatusErrors = {}));
var PadErrors;
(function (PadErrors) {
    PadErrors["PAD_NOT_LINKED"] = "This pad should be linked to perform this action";
    PadErrors["PAD_CONFIG_NOT_FOUND"] = "The pad doesn't exist in the db";
})(PadErrors = exports.PadErrors || (exports.PadErrors = {}));
var GraphQLErrors;
(function (GraphQLErrors) {
    GraphQLErrors["BAD_REQUEST"] = "Bad Request";
})(GraphQLErrors = exports.GraphQLErrors || (exports.GraphQLErrors = {}));
var ResetPasswordErrors;
(function (ResetPasswordErrors) {
    ResetPasswordErrors["THERE_IS_NO_USER_WITH_THIS_EMAIL"] = "There is no user with email";
    ResetPasswordErrors["RESET_TOKEN_NOT_FOUND"] = "Reset token not found";
    ResetPasswordErrors["PASSWORD_IS_ALREADY_RESETED"] = "Password is already reseted";
    ResetPasswordErrors["PASSWORD_RESET_TIME_EXPIRED"] = "Password reset time expired";
})(ResetPasswordErrors = exports.ResetPasswordErrors || (exports.ResetPasswordErrors = {}));
